(() => {
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-material-help][open]').forEach((help) => {
      if (!help.contains(event.target)) help.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const help = event.target.closest('[data-material-help]');
    if (!help || !help.open) return;
    help.open = false;
    help.querySelector('summary')?.focus();
  });
})();
